/* Sleepee 12.10 (uwaga klienta po przeglądzie mobile, pkt 9): na kartach produktów klik w próbkę wzoru/koloru
   zmienia podgląd karty — zdjęcie, link, a gdzie są dane także nazwę i cenę — zamiast od razu otwierać produkt.
   Kartę otwiera klik w zdjęcie lub nazwę. Dane w atrybutach data-sw-* (snippets/sleepee-mk-card, sleepee-wall-card). */
(function () {
  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('.mk-sw[data-sw-url]');
    if (!sw) return;
    var card = sw.closest('.mk-pcard');
    if (!card) return;
    e.preventDefault(); e.stopPropagation();
    if (sw.dataset.swUrl) card.setAttribute('href', sw.dataset.swUrl);
    var img = card.querySelector('.mk-shot img');
    if (img && sw.dataset.swImg) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = sw.dataset.swImg; }
    if (sw.dataset.swTitle) { var h = card.querySelector('h3'); if (h) { h.textContent = sw.dataset.swTitle; if (img) img.alt = sw.dataset.swTitle; } }
    if (sw.dataset.swPrice) { var p = card.querySelector('.mk-price'); if (p) p.innerHTML = sw.dataset.swPrice; }
    Array.prototype.forEach.call(card.querySelectorAll('.mk-sw'), function (x) { x.classList.toggle('is-on', x === sw); });
    /* serce ulubionych na karcie idzie za wybranym wzorem */
    var heart = card.querySelector('.mk-heart[data-wish]'), m = (sw.dataset.swUrl || '').match(/\/products\/([^\/?#]+)/);
    if (heart && m) { heart.setAttribute('data-wish', m[1]); document.dispatchEvent(new CustomEvent('sleepee:wish:repaint')); }
  }, true);
})();

/* 3.11 (GLOBAL-001): szybki zakup na kartach — snippets/sleepee-card-buy.liquid.
   Jeden dostępny wariant → od razu dodanie / kasa; kilka → wybór na karcie (pigułki), potem akcja. */
(function () {
  if (window.__slQuickBuy) return; window.__slQuickBuy = true;
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function productUrl(card) { var h = (card && card.getAttribute('href')) || ''; return h.split('?')[0].split('#')[0]; }
  function msg(box, t) { var m = box.querySelector('[data-sl-qb-msg]'); if (m) m.textContent = t || ''; }
  function addToCart(id) {
    return fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'error'); return j; }); });
  }
  function act(box, id, kind) {
    box.classList.add('is-busy'); msg(box, '');
    addToCart(id).then(function () {
      if (kind === 'buy') { window.location.href = root() + 'checkout'; return; }
      box.classList.remove('is-busy'); box.classList.add('is-added'); msg(box, box.dataset.added || '');
      /* 3.11 audyt mobile: po dodaniu zwiń pigułki rozmiarów, żeby karta wróciła do zwykłej wysokości */
      var sz = box.querySelector('[data-sl-qb-sizes]'); if (sz) { sz.hidden = true; sz.innerHTML = ''; } box.classList.remove('is-choosing');
      setTimeout(function () { box.classList.remove('is-added'); msg(box, ''); }, 2500);
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      var drawer = document.querySelector('cart-drawer');
      if (drawer) setTimeout(function () { drawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show')); }, 350);
    }).catch(function (err) { box.classList.remove('is-busy'); msg(box, (err && err.message && err.message !== 'error') ? err.message : (box.dataset.error || '')); });
  }
  function handle(trigger) {
    var box = trigger.closest('[data-sl-qb]'); if (!box || box.classList.contains('is-busy')) return;
    var card = box.closest('a');
    var vid = trigger.getAttribute('data-variant');
    if (vid) { act(box, Number(vid), box.dataset.kind || 'add'); return; }
    var kind = trigger.getAttribute('data-sl-qb-act'); box.dataset.kind = kind;
    var url = productUrl(card); if (!url) return;
    box.classList.add('is-busy');
    fetch(url + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (p) {
      box.classList.remove('is-busy');
      var av = (p.variants || []).filter(function (v) { return v.available; });
      if (!av.length) { msg(box, box.dataset.error || ''); return; }
      if (av.length === 1) { act(box, av[0].id, kind); return; }
      var sizes = box.querySelector('[data-sl-qb-sizes]');
      /* podpis tylko z opcji, które się różnią (np. rozmiar bez stałego „TOG 2.5”) */
      var diff = [0, 1, 2].filter(function (i) { var k = 'option' + (i + 1); return av.some(function (v) { return v[k] !== av[0][k]; }); });
      sizes.innerHTML = '<span class="sl-qb__lab">' + (box.dataset.choose || '') + '</span>' + av.map(function (v) {
        var lab = diff.length ? diff.map(function (i) { return v['option' + (i + 1)]; }).join(' / ') : (v.public_title || v.title);
        return '<span class="sl-qb__size" role="button" tabindex="0" data-variant="' + v.id + '">' + String(lab).replace(/</g, '&lt;') + '</span>';
      }).join('');
      sizes.hidden = false; box.classList.add('is-choosing');
      var first = sizes.querySelector('[data-variant]'); if (first) first.focus({ preventScroll: true });
    }).catch(function () { box.classList.remove('is-busy'); msg(box, box.dataset.error || ''); });
  }
  function on(e) {
    var t = e.target.closest && e.target.closest('[data-sl-qb] [data-sl-qb-act], [data-sl-qb] [data-variant]');
    if (!t) return;
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault(); e.stopPropagation(); handle(t);
  }
  document.addEventListener('click', on, true);
  document.addEventListener('keydown', on, true);
  /* klik gdziekolwiek w obszar przycisków (odstępy) nie otwiera produktu */
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-sl-qb]') && !e.target.closest('[data-sl-qb-act],[data-variant]')) { e.preventDefault(); } }, true);
})();

/* 3.11 (CART-002): koszyk — dwa rzędy polecanych (sections/sleepee-cart-recs.liquid, przez Section Rendering API).
   Szuflada Broadcast przebudowuje swoją treść po każdej zmianie, więc moduł wstawiamy ponownie (MutationObserver). */
(function () {
  if (window.__slCartRecs) return; window.__slCartRecs = true;
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  var html = null, loading = null, stamp = 0;
  function load() {
    var my = ++stamp;
    loading = fetch(root() + '?section_id=sleepee-cart-recs', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) { if (my !== stamp) return; var d = document.createElement('div'); d.innerHTML = t; var n = d.querySelector('[data-sl-crecs]'); var nh = n ? n.outerHTML : ''; var same = nh === html; html = nh; place(!same); })
      .catch(function () {});
    return loading;
  }
  function targets() {
    var out = [];
    var body = document.querySelector('cart-drawer [data-cart-drawer-body]'); if (body) out.push(body);
    if (document.body.classList.contains('template-cart') || /\/cart\/?$/.test(location.pathname)) {
      var inner = document.querySelector('.cart__inner') || document.querySelector('[data-cart-form]'); if (inner) out.push(inner);
    }
    return out;
  }
  function place(force) {
    if (html === null) return;
    targets().forEach(function (t) {
      var cur = t.querySelector(':scope > [data-sl-crecs]');
      if (cur && !force) return;
      if (cur) cur.remove();
      if (html) t.insertAdjacentHTML('beforeend', html);
    });
  }
  ['theme:cart:change', 'theme:cart:refresh', 'theme:cart:update', 'theme:product:add'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(load, 400); }); });
  document.addEventListener('theme:cart-drawer:open', function () { if (html === null) load(); else place(false); });
  function init() {
    load();
    var dr = document.querySelector('cart-drawer');
    if (dr && window.MutationObserver) new MutationObserver(function () { var b = dr.querySelector('[data-cart-drawer-body]'); if (b && !b.querySelector(':scope > [data-sl-crecs]')) place(false); }).observe(dr, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
